/**
 * Модуль для автодополнения пользователей
 */

/**
 * Создаёт менеджер для автодополнения пользователей
 */
export function createUserAutocompleteManager({
  buildAuthHeaders,
  getApiUrl,
  escapeHtmlFn,
  documentRef = document,
}) {
  let searchTimeout = null;
  let cachedUsers = [];

  /**
   * Ищет пользователей по запросу
   */
  async function searchUsers(query) {
    try {
      const apiUrl = getApiUrl();
      const response = await fetch(
        `${apiUrl}/users/search?q=${encodeURIComponent(query)}`,
        {
          headers: buildAuthHeaders(),
        },
      );

      const data = await response.json();
      if (data.success && data.users) {
        cachedUsers = data.users;
        renderUserAutocomplete(data.users);
      } else {
        hideUserAutocomplete();
      }
    } catch (error) {
      console.error("Search users error:", error);
      hideUserAutocomplete();
    }
  }

  /**
   * Рендерит список пользователей в автодополнении
   */
  function renderUserAutocomplete(users) {
    const container = documentRef.getElementById("user-autocomplete");
    const list = documentRef.getElementById("autocomplete-list");

    if (!users || users.length === 0) {
      hideUserAutocomplete();
      return;
    }

    if (!list) return;

    list.innerHTML = "";

    users.forEach((user) => {
      const item = documentRef.createElement("div");
      item.style.cssText =
        "padding: 12px; cursor: pointer; border-bottom: 1px solid var(--tg-theme-hint-color); transition: background 0.2s;";

      const username = escapeHtmlFn(user.username || "");
      const coins = user.coins || 0;
      const stars = user.stars || 0;

      item.innerHTML = `
        <div style="font-weight: 600;">@${username}</div>
        <div style="font-size: 12px; color: var(--tg-theme-hint-color);">💰 ${coins} монет | ⭐ ${stars} звёзд</div>
      `;

      item.onmouseover = () => {
        item.style.background = "var(--tg-theme-secondary-bg-color)";
      };
      item.onmouseout = () => {
        item.style.background = "transparent";
      };
      item.onclick = () => {
        const input = documentRef.getElementById("gift-recipient");
        if (input) {
          input.value = `@${username}`;
        }
        hideUserAutocomplete();
      };

      list.appendChild(item);
    });

    if (container) {
      container.style.display = "block";
    }
  }

  /**
   * Скрывает автодополнение
   */
  function hideUserAutocomplete() {
    const container = documentRef.getElementById("user-autocomplete");
    if (container) {
      container.style.display = "none";
    }
  }

  /**
   * Инициализирует автодополнение для поля ввода
   */
  function initUserAutocomplete() {
    const input = documentRef.getElementById("gift-recipient");
    if (!input) return;

    input.addEventListener("input", (event) => {
      const query = event.target.value.trim();

      if (searchTimeout) {
        clearTimeout(searchTimeout);
      }

      if (query.length < 2) {
        hideUserAutocomplete();
        return;
      }

      searchTimeout = setTimeout(() => {
        searchUsers(query);
      }, 300);
    });

    // Скрываем автодополнение при клике вне его
    documentRef.addEventListener("click", (event) => {
      if (
        !event.target.closest("#user-autocomplete") &&
        !event.target.closest("#gift-recipient")
      ) {
        hideUserAutocomplete();
      }
    });
  }

  return {
    initUserAutocomplete,
    searchUsers,
    hideUserAutocomplete,
    renderUserAutocomplete,
  };
}


